var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap relative"},[_c('SiteHeader'),_c('people-index',{attrs:{"standalone":"true"}}),_c('SiteFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }